{
  "name": "ngx-rtapp",
  "version": "7.1.0",
  "scripts": {
    "ng": "ng",
    "start": "ng serve --proxy-config proxy.conf.json --port 4200",
    "start:ref": "ng serve --proxy-config proxy.conf.json --port 4201",
    "build": "ng build",
    "build:prod": "npm version patch && ng build --configuration production",
    "test": "ng test",
    "lint": "ng lint",
    "e2e": "ng e2e"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^21.2.25",
    "@angular/cdk": "^21.2.14",
    "@angular/common": "^21.2.25",
    "@angular/compiler": "^21.2.25",
    "@angular/core": "^21.2.25",
    "@angular/forms": "^21.2.25",
    "@angular/material": "^21.2.14",
    "@angular/platform-browser": "^21.2.25",
    "@angular/platform-browser-dynamic": "^21.2.25",
    "@angular/router": "^21.2.25",
    "core-js": "~3.49.0",
    "date-fns": "^3.6.0",
    "lodash-es": "^4.18.0",
    "rxjs": "~7.8.2",
    "signature_pad": "^5.1.3",
    "tslib": "^2.6.2",
    "zone.js": "~0.15.1"
  },
  "devDependencies": {
    "@angular/build": "^21.2.29",
    "@angular/cli": "^21.2.29",
    "@angular/compiler-cli": "^21.2.25",
    "@angular/language-service": "^21.2.25",
    "@types/lodash-es": "^4.17.12",
    "@types/node": "~13.7.4",
    "ng-packagr": "^21.2.7",
    "ts-node": "~7.0.0",
    "typescript": "~5.9.3"
  }
}
